import {
  GET_ALL_RACKS,
  GET_ALL_RACKS_SUCCESS,
  GET_ALL_RACKS_ERROR,
} from "./actionTypes";

export const getAllRacks = (user) => {
  return {
    type: GET_ALL_RACKS,
    payload: { user },
  };
};

export const getAllRacksSuccess = (racks, message) => {
  return {
    type: GET_ALL_RACKS_SUCCESS,
    payload: { racks, message },
  };
};

export const getAllRacksError = (msg) => {
  return {
    type: GET_ALL_RACKS_ERROR,
    payload: msg,
  };
};
